import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Users } from "lucide-react";
import { useChildInstitutions } from "@/hooks/useAcademicMarket";

interface AccountChildrenTabProps {
  accountId: string;
}

export function AccountChildrenTab({ accountId }: AccountChildrenTabProps) {
  const navigate = useNavigate();
  const { data: children, isLoading } = useChildInstitutions(accountId);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary" />
      </div>
    );
  }

  if (!children || children.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <Users className="h-12 w-12 mx-auto mb-3 opacity-50" />
        <p>No child institutions</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {children.map((child: any) => (
          <div
            key={child.id}
            className="p-4 border rounded-lg hover:bg-muted/50 cursor-pointer transition-colors"
            onClick={() => navigate(`/accounts/${child.id}`)}
          >
            <p className="font-medium">{child.institution_name}</p>
            <div className="flex items-center gap-2 mt-1.5">
              {child.institution_type && (
                <Badge variant="outline" className="text-xs">
                  {child.institution_type.replace(/_/g, " ").replace(/^ai /, "")}
                </Badge>
              )}
              {child.domain && (
                <span className="text-xs text-muted-foreground">{child.domain}</span>
              )}
            </div>
            <div className="flex items-center gap-4 mt-2 text-xs text-muted-foreground">
              {child.lab_count > 0 && <span>{child.lab_count} labs</span>}
              {child.child_count > 0 && <span>{child.child_count} children</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
